<template>
  <div>
    <h2><i>Interact with this Article</i></h2>
    <section class="interact">
      <media-container v-if="article" :issue="article" :figures="article.files.figures"></media-container>
    </section>
  </div>
</template>

<script>
  import MediaContainer from '@/components/shared/MediaContainerComponent'
  export default {
    name: 'interact',
    components: {
      MediaContainer
    },
    data () {
      return {
        article: false
      }
    },
    created () {
      if (this.$parent.article) {
        this.article = Object.assign({}, this.$parent.article)
      }
      this.$parent.$parent.prevPage = {name: 'article-metrics'}
      this.$parent.$parent.nextPage = {name: 'article-media'}
      this.$parent.$parent.prevSlide = false
      this.$parent.$parent.nextSlide = {name: 'article-interact-tables'}
    }
  }
</script>


<style lang="scss">
  section.interact {
    .slides-container {
      height: calc(100vh - 200px) !important;
    }
    .media-wrapper {
      max-height: calc(100vh - 202px) !important;
    }
  }

</style>



// WEBPACK FOOTER //
// InteractPage.vue?46da4536